import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import breakpoints from 'static/script/utils/breakpoints';
import ModalZoom from 'static/script/app/ui/view-item/image-zoom-modal';
import FullpageZoom from 'static/script/app/ui/view-item/image-zoom-fullpage';

function ImageZoomUI() {

    this.defaultAttrs({
        imageZoomAttribute: 'data-image-zoom',
        image: '[data-image-zoom]',
        currentImageButton: '[data-current-image-zoom]'
    });

    this._zoomClick = function (evt) {
        let src = $(evt.target).attr('data-image-zoom');
        this._trackEvent(evt);
        this._zoom(src);
    };

    this._zoom = function (current) {
        let allImages = this.select('image').map(function () { return $(this).attr('data-image-zoom'); });
        if (breakpoints.isVisible(breakpoints.large)) {
            this.trigger('ui:view-item:image-zoom-modal', {
                current: current,
                all: allImages
            });
        } else {
            this.trigger('ui:view-item:image-zoom-fullpage', {
                current: current,
                all: allImages
            });
        }
        this._triggerZoomedEvent();
    };

    this._triggerZoomedEvent = function () {
        if (this.zoomedEventTriggered) {
            return;
        }
        this.trigger(document, 'analytics:track-event', {
            category: 'Carousel',
            action: 'Zoom'
        });
        this.zoomedEventTriggered = true;
    };

    this._updateCurrentImageZoomButton = function (evt, opts) {
        let currentItem = opts.currentItem,
            el = $(currentItem).find(this.attr.image),
            newZoomUrl;

        if (el.length > 0) {
            newZoomUrl = el.attr(this.attr.imageZoomAttribute);
            this.select('currentImageButton').attr(this.attr.imageZoomAttribute, newZoomUrl);
        }
    };

    this._trackEvent = function (evt) {
        let label = 'Click on image';

        if (evt.target.hasAttribute('data-current-image-zoom')) {
            label = 'Click on zoom icon';
        }

        this.trigger('analytics:track-event', {
            category: 'VIP',
            action: 'Zoom image',
            label: label
        });
    };

    this.after('initialize', function () {
        ModalZoom.attachTo(this.$node);
        FullpageZoom.attachTo(this.$node);

        this.on('click', {
            image: this._zoomClick
        });

        this.on(document, 'ui:carousel:after-move', this._updateCurrentImageZoomButton);
    });
}

module.exports = defineComponent.component(ImageZoomUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/image-zoom.js